import {
  SITES_FETCH,
  SITE_CREATE,
  SITE_UPDATE,
} from '../actions';

const INIT_STATE = {
  list: [],
  current: null,
};

export default function sitesReducer(state = INIT_STATE, action) {
  switch (action.type) {
    case SITES_FETCH.SUCCESS:
      return { ...state, list: action.payload };
    case SITE_CREATE.SUCCESS:
      return { ...state, list: [action.payload, ...state.list] };
    case SITE_UPDATE.SUCCESS: {
      const updated = action.payload;
      return {
        ...state,
        list: state.list.map((s) => (s.site_id === updated.site_id ? updated : s)),
      };
    }
    default:
      return state;
  }
}
